export class SIQHandOffBannerTheme {
  backgroundColor = "null";
  textColor = "null";
  buttonTitleColor = "null";
}
//# sourceMappingURL=SIQHandOffBannerTheme.js.map